<template>
  <div>
    <!-- 不带安装的导航条 -->
    <via-nav-bar @click-left="$router.$back()">
      <div
        slot="title"
        class="nav-title"
        @click="scrollToTop"
      >文章详情</div>
    </via-nav-bar>
    <div
      class="content"
      :style="{height: $vw(contentHeight)}"
    >
      <div
        ref="top"
        class="sroll-top"
      />
      <!-- markdown解析器 -->
      <mavon-editor
        class="md md-pink"
        :value="markdown.content"
        :subfield="markdown.subfield"
        :default-open="markdown.defaultOpen"
        :toolbars-flag="markdown.toolbarsFlag"
        :box-shadow="markdown.boxShadow"
        :code-style="markdown.codeStyle"
        :editable="markdown.editable"
        :scroll-style="markdown.scrollStyle"
      />
    </div>
  </div>
</template>

<script>
import { initDocumentListen, hookAllImageUrl } from '~/utils/func'

export default {
  name: 'ArticleDetail',
  inject: ['reload'],
  data() {
    return {
      pageLoading: true,
      article: {},
      markdown: {
        content: '',
        subfield: false, // 单双栏模式
        defaultOpen: 'preview', // edit： 默认展示编辑区域 ， preview： 默认展示预览区域
        boxShadow: false,
        codeStyle: 'vs2015',
        editable: false,
        toolbarsFlag: false,
        scrollStyle: true
      }
    }
  },
  computed: {
    // rpx
    contentHeight() {
      return this.$pxToRpx(this.$clientHeight) - 46
    }
  },
  watch: {
    '$route.params.id'(newValue, oldeValue) {
      this.reload()
    }
  },
  mounted() {
    // 初始化监听回调
    initDocumentListen()
    document.addEventListener('click', window.listenDocument, true)
    this.scrollToTop()
    this.getArticle()
  },
  beforeDestroy() {
    // 移除监听
    document.removeEventListener('click', window.listenDocument, true)
  },
  updated() {
    hookAllImageUrl(document)
  },
  methods: {
    getArticle() {
      this.$api.article.findById(this.$route.params.id).then(res => {
        this.pageLoading = false
        this.article = res.data
        this.markdown.content = res.data.content
      }).catch(() => { this.pageLoading = false })
    },
    // 回到顶部
    scrollToTop() {
      const target = this.$refs['top']
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }
}
</script>

<style scoped>
.content {
  position: fixed;
  top: 46px;
  left: 0;
  z-index: 999;
  width: 375px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.sroll-top {
  width: 375px;
}
.md {
  z-index: auto !important;
  min-height: 0;
}
</style>
<style>
@import '../../static/css/markdown-theme-pink.css';
.page-middle .van-skeleton__avatar--square {
  border-radius: 15px;
}
</style>
